import Languages from '../../menus/model/Languages';
export default class ProjectsNumberDescComponentIdTranslations {
    constructor(translation) {
        const { id, languages_code, description, title } = translation;
        this.id = id;
        this.languages_code = new Languages(languages_code);
        this.title = title;
        this.description = description;
    }
}
